<!--
  - Copyright (c) 2020.
  -
  - Unless required by applicable law or agreed to in writing, software
  - distributed under the License is distributed on an "AS IS" BASIS,
  - WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
  - See the License for the specific language governing permissions and
  - limitations under the License.
  -
  -->

<template>
    <div>
        <van-nav-bar
            :title="title"
            left-arrow
            @click-left="$router.go(-1)"
        >
            <template #right>
                <van-icon name="down" size="18" @click="downloadClicked"/>
            </template>
        </van-nav-bar>

        <van-tabs v-model="active">
            <van-tab v-for="tab in tabs" :title="tab.title">
                <div style="background: white; height: calc(100vh - 46px)" class="my-content">
                    <PdfViewer v-if="tab.url" :url="tab.url"/>
                </div>
            </van-tab>
        </van-tabs>


        <van-action-sheet v-model="show" :actions="actions" @select="onSelect" />
    </div>
</template>

<script>
    import PdfViewer from '../components/PdfViewer';
    import http from "@/utils/http";

    export default {
        name: "PDF",
        components: {
            PdfViewer
        },
        data() {
            return {
                active:0,
                tabs:[],
                urls: [],
                title: '',

                show: false,
                actions: [],
            }
        },
        created() {
            this.urls = this.$route.query.urls?decodeURIComponent(this.$route.query.urls).split(','):[];
            if (this.urls.length === 0) {
                this.router.go(-1);
                return;
            }
            var tabs = [];
            var actions = [];
            for(var i=0; i<this.urls.length; i++) {
                tabs.push({url: this.urls[i], title: '第'+(i+1)+"份"});
                actions.push({name: '下载第'+(i+1)+"份"})
            }
            this.tabs = tabs;
            this.actions = actions;

            const title = this.$route.query.title;
            if (!title) {
                const lastIdx = this.url.lastIndexOf('/');
                if (lastIdx > 0) {
                    this.title = this.url.substring(lastIdx + 1, this.url.length);
                }
            } else {
                this.title = title;
            }
            // console.log(this.$route.query)
        },
        methods: {
            downloadClicked() {
                this.$router.push('/downloads?title=体检报告'+'&urls='+encodeURIComponent(this.urls.join(",")))
                // this.show = true;
            },
            onSelect(action, idx) {
                // 默认情况下点击选项时不会自动收起
                // 可以通过 close-on-click-action 属性开启自动收起
                this.show = false;
                this.download(idx);
            },
            download(idx) {
                var url = this.tabs[idx].url+"?token="+localStorage.getItem("token");
                http.get(url, {
                    headers: {
                        'Content-Disposition': "attachment; filename=download.pdf",
                        'Content-Type': 'application/octet-stream'
                    },
                    responseType: 'arraybuffer',//or responseType: 'blob', //important
                }
                ).then((response) => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', this.title+"_"+(idx+1)+".pdf");
                    document.body.appendChild(link);
                    link.click();
                    link.remove();
                }).catch((error) => console.log(error));
            }
        }
    }
</script>

<style scoped>

</style>